import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    msgCount: 0,
  },
  getters: {

  },
  mutations: {
    changeMsgCount(state, count) {
      state.msgCount = count
    },
    removeMsgCount(state) {
      state.msgCount -= 1
    }
  },
  actions: {

  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js